module.exports = __webpack_public_path__ + "static/media/logoWithText.6a74c893.png";